import { TableColumn } from "@backstage/core-components";
import { CatalogTable, CatalogTableColumnsFunc, CatalogTableRow } from "@backstage/plugin-catalog";
import { EntityRefLinks } from "@backstage/plugin-catalog-react";
import { Box, LinearProgress } from "@material-ui/core";

const createApplicationDivisionColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Company',
    field: 'entity.spec.division',
    render: ({ entity }) => {
        const division = entity.spec?.division;
        const divisionRef = typeof division === 'string' ? division : undefined;
        const entityRefs = divisionRef ? [divisionRef] : [];
        return (
            <EntityRefLinks
                entityRefs={entityRefs}
                defaultKind="division"
            />
        );
    },
});

const createApplicationManagerColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Business Manager',
    field: 'entity.spec.manager',
    render: ({ entity }) => {
        const manager = entity.spec?.manager;
        const managerRef = typeof manager === 'string' ? manager : undefined;
        const entityRefs = managerRef ? [managerRef] : [];
        return (
            <EntityRefLinks
                entityRefs={entityRefs}
                defaultKind="user"
            />
        );
    },
});

const createApplicationITManagerColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Application IT Owner',
    field: 'entity.spec.itManager',
    render: ({ entity }) => {
        const itManager = entity.spec?.itManager;
        const itManagerRef = typeof itManager === 'string' ? itManager : undefined;
        const entityRefs = itManagerRef ? [itManagerRef] : [];
        return (
            <EntityRefLinks
                entityRefs={entityRefs}
                defaultKind="user"
            />
        );
    },
});

const createApplicationNumberColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Number',
    field: 'entity.spec.number',
    cellStyle: { fontWeight: 'bold' },
});

const createApplicationCategoryColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Category',
    field: 'entity.spec.category',
});

const createProjectNumberColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Number',
    field: 'entity.spec.number',
    cellStyle: { fontWeight: 'bold' },
});

const createProjectManagerColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Project Manager',
    field: 'entity.spec.projectManager',
    render: ({ entity }) => {
        const projectManager = entity.spec?.projectManager;
        const projectManagerRef = typeof projectManager === 'string' ? projectManager : undefined;
        const entityRefs = projectManagerRef ? [projectManagerRef] : [];
        return (
            <EntityRefLinks
                entityRefs={entityRefs}
                defaultKind="user"
            />
        );
    },
});

const createProjectPriorityColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Priority',
    field: 'entity.spec.priority',
});

const createProjectStatusColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Status',
    field: 'entity.spec.status',
    render: ({ entity }) => {
        const status = (entity.spec?.status as string ?? '').toLowerCase();

        const color =
            status.includes('verde') ? '#4CAF50' :      // verde
                status.includes('amarillo') ? '#FFC107' :       // amarillo
                    status.includes('rojo') ? '#F44336' :        // rojo
                        '#BDBDBD';                                  // gris por defecto

        return (
            <Box display="flex" alignItems="center">
                <Box
                    style={{
                        width: 15,
                        height: 15,
                        borderRadius: '50%',
                        backgroundColor: color,
                        marginRight: 8,
                    }}
                />
                {/* {row.entity.spec?.status ?? '—'} */}
            </Box>
        );
    },
});

const createProjectCompletedColumn = (): TableColumn<CatalogTableRow> => ({
    title: '% Completed',
    field: 'entity.spec.percentCompleted',
    render: ({ entity }) => {
        const rawValue = entity.spec?.percentCompleted;

        const stringValue =
            typeof rawValue === 'string'
                ? rawValue.replace(',', '.')
                : String(rawValue ?? 0);
        const percent = Number(stringValue);

        return (
            <Box display="flex" alignItems="center" width={180}>
                <Box width="100%">
                    <LinearProgress
                        variant="determinate"
                        value={percent}
                    />
                </Box>
                {/* Contenedor fijo para el número */}
                <Box width="100%" textAlign="center">
                    <strong>{percent}%</strong>
                </Box>
            </Box>
        );
    },
});

const createComponentApplicationColumn = (): TableColumn<CatalogTableRow> => ({
    title: 'Application',
    field: 'entity.spec.system',
    render: ({ entity }) => {
        const application = entity.spec?.system;
        const applicationRef = typeof application === 'string' ? application : undefined;
        const entityRefs = applicationRef ? [applicationRef] : [];
        return (
            <EntityRefLinks
                entityRefs={entityRefs}
                defaultKind="application"
            />
        );
    }
});

export const columns: CatalogTableColumnsFunc = entityListContext => {
    if (entityListContext.filters.kind?.value === 'project') {
        return [
            CatalogTable.columns.createNameColumn(),
            createProjectNumberColumn(),
            CatalogTable.columns.createSpecTypeColumn(),
            CatalogTable.columns.createSpecLifecycleColumn(),
            createProjectManagerColumn(),
            createProjectPriorityColumn(),
            createProjectStatusColumn(),
            createProjectCompletedColumn(),
            // ...CatalogTable.defaultColumnsFunc(entityListContext),
        ];
    }
    if (entityListContext.filters.kind?.value === 'application') {
        return [
            CatalogTable.columns.createNameColumn(),
            createApplicationNumberColumn(),
            createApplicationDivisionColumn(),
            createApplicationCategoryColumn(),
            createApplicationManagerColumn(),
            createApplicationITManagerColumn(),
            CatalogTable.columns.createSpecLifecycleColumn(),
            // ...CatalogTable.defaultColumnsFunc(entityListContext),
        ];
    }
    if (entityListContext.filters.kind?.value === 'division') {
        return [
            CatalogTable.columns.createNameColumn(),
            CatalogTable.columns.createSpecTypeColumn(),
            // ...CatalogTable.defaultColumnsFunc(entityListContext),
        ];
    }
    if (entityListContext.filters.kind?.value === 'component') {
        return [
            CatalogTable.columns.createNameColumn(),
            createComponentApplicationColumn(),
            CatalogTable.columns.createSpecTypeColumn(),
            CatalogTable.columns.createSpecLifecycleColumn(),
            // ...CatalogTable.defaultColumnsFunc(entityListContext),
        ];
    }

    return CatalogTable.defaultColumnsFunc(entityListContext);
};